module.exports = __webpack_public_path__ + "img/JRB-01-1.072a5a06.jpg";